import { Button, Layout } from "antd";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export const MainWrapper = styled(Layout)`
    height: 100dvh;
    width: 100%;
`;

export const StyledPlanButton = styled(Button)<{
    $isPlanActive: boolean;
}>`
    font-size: 20px;

    ${({ $isPlanActive, theme }) => {
        if (!$isPlanActive) return;

        return css`
            background-color: ${theme.colors.green}2b;
            border: 1px solid ${theme.colors.green}21;
        `;
    }}
`;

export const StyledPromoLink = styled(Link)`
    display: block;
    font-size: 20px;
    line-height: 100%;
    padding: 6px;
    color: ${({ theme }) => theme.colors.green};
`;
